import styled from 'styled-components';

export const Base = styled.div`
	position: relative;
	display: flex;
	flex-direction: column;
	padding: 10px 14px;
	background-color: ${({ theme }) => `${theme.blue[500]}14`};
	border: 1px solid ${({ theme }) => theme.blue[500]};
	border-radius: 6px;
	margin-bottom: 2px;
	gap: 8px;
`;

export const Header = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
`;

export const Title = styled.div`
	font-size: 13px;
	font-weight: 600;
	color: ${({ theme }) => theme.gray[800]};
	line-height: 1.4;
`;

export const CloseButton = styled.button`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 20px;
	height: 20px;
	padding: 0;
	background: none;
	border: none;
	color: ${({ theme }) => theme.gray[400]};
	border-radius: 4px;
	flex-shrink: 0;
	transition: all 0.15s ease;

	&:hover {
		color: ${({ theme }) => theme.gray[700]};
		background-color: ${({ theme }) => theme.gray[200]};
	}
`;

export const ImpactRows = styled.div`
	display: flex;
	flex-direction: column;
	gap: 6px;
`;

export const ImpactRow = styled.div`
	display: flex;
	align-items: center;
	gap: 6px;
	font-size: 13px;
	color: ${({ theme }) => theme.gray[600]};
	line-height: 1.4;
	overflow: hidden;
`;

export const ImpactText = styled.span`
	color: ${({ theme }) => theme.gray[600]};
	white-space: nowrap;
`;

export const CountLink = styled.span`
	color: ${({ theme }) => theme.gray[700]};
	text-decoration: underline dotted ${({ theme }) => theme.gray[400]};
	text-underline-offset: 3px;
	white-space: nowrap;
	transition: color 0.15s ease;

	&:hover {
		color: ${({ theme }) => theme.gray[900]};
		text-decoration-color: ${({ theme }) => theme.gray[700]};
	}
`;

export const Actions = styled.div`
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 8px;
	margin-top: 2px;
`;

const Button = styled.button`
	display: flex;
	align-items: center;
	padding: 4px 10px;
	font-size: 13px;
	font-weight: 500;
	border-radius: 6px;
	transition: all 0.15s ease;
	flex-shrink: 0;
	white-space: nowrap;
	border: 1px solid;
`;

export const AutofixButton = styled(Button)`
	gap: 6px;
	color: ${({ theme }) => theme.gray[0]};
	background-color: ${({ theme }) => theme.blue[500]};
	border-color: ${({ theme }) => theme.blue[500]};

	&:hover {
		background-color: ${({ theme }) => theme.blue[400]};
		border-color: ${({ theme }) => theme.blue[400]};
	}

	&:active {
		background-color: ${({ theme }) => theme.blue[700]};
		border-color: ${({ theme }) => theme.blue[700]};
	}

	&:disabled {
		opacity: 0.6;
		pointer-events: none;
	}
`;

export const UndoButton = styled(Button)`
	color: ${({ theme }) => theme.gray[600]};
	background: none;
	border-color: ${({ theme }) => theme.gray[400]};

	&:hover {
		color: ${({ theme }) => theme.gray[800]};
		border-color: ${({ theme }) => theme.gray[600]};
	}
`;

